import { render, staticRenderFns } from "./summaryTable.vue?vue&type=template&id=a7de6896&scoped=true"
import script from "./summaryTable.vue?vue&type=script&lang=js"
export * from "./summaryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7de6896",
  null
  
)

export default component.exports